enum LocalStorageKeys {
  skin = 'skin',
  mlbSessionToken = 'mlbSessionToken',
  csrfToken = 'csrf',
  plates = 'plates'
}

export default LocalStorageKeys